import styled, { css } from 'styled-components'

const ProjectName = styled.svg``

const ProjectCreatedDate = styled.svg``

const PersonName = styled.svg``

const Square = styled.svg``

const Email = styled.svg``

const Call = styled.svg``

const UserType = styled.svg``

const ExpandLess = styled.svg``

const ExpandMore = styled.svg``

const ChevronRight = styled.svg``

const InsertChartOutlined = styled.svg``

const PersonSearch = styled.svg``

const WorkOutline = styled.svg``

const EmojiEvents = styled.svg``

const SpaceDashboard = styled.svg``

const FileDownload = styled.svg``

const Notifications = styled.svg``

const Svg = styled.svg`
    fill: #000;
    width: 19px;
    height: 19px;

    ${({ phone }) => phone && css`
        width: 30px;
        height: 30px;
    `}
`

const ThumbUpBlack = styled.svg`

    ${({ name }) => name === 'admin' && css`
        width: 50px;
        height: 50px;
    `}

`
const ThumbDownBlack = styled.svg`

    ${({ name }) => name === 'admin' && css`
        width: 50px;
        height: 50px;
    `}

`
const AlarmBlack = styled.svg`

    ${({ name }) => name === 'admin' && css`
        width: 50px;
        height: 50px;
    `}

`
const DateRangeBlack = styled.svg`

    ${({ name }) => name === 'admin' && css`
        width: 50px;
        height: 50px;
    `}

`
const SpaceSuperAdm = styled.svg`

    ${({ name }) => name === 'navigation' && css`
        width: 13px;
        height: 13px;

        @media screen and (max-width: 600px) {
            width: 12px;
            height: 11px;
        }
    `}

`
const Edit = styled.svg`
    width: 18px;
    height: 18px;
`
const PersonOutline = styled.svg`

    ${({ name }) => name === 'profile' && css`
        width: 45px;
        height: 45px;
    `}

    @media screen and (max-width: 600px) {
        width: 26px;
        height: 26px;
    }
`
const SettingsOutline = styled.svg`

    ${({ name }) => name === 'profile' && css`
        width: 40px;
        height: 40px;
    `}

    @media screen and (max-width: 600px) {
        width: 26px;
        height: 26px;
    }
`
const HelpOutline = styled.svg`
    width: 36px;
    height: 36px;
`
const AddPhoto = styled.svg`

    ${({ name }) => name === 'profile_update' && css`
        width: 36px;
        height: 36px;
    `}

    ${({ name }) => name === 'register_update' && css`

        width: 42px;
        height: 42px;
        fill: #a4a4a4;

        @media screen and (max-width: 600px) {

            width: 36px;
            height: 36px;

        }

    `}
`
const NoSatisfied = styled.svg`

        ${({ name }) => name === 'no_help' && css`
            width: 80px;
            height: 80px;
        `}

        @media screen and (max-width: 600px) {
            width: 48px;
            height: 48px;
            margin-bottom: 10px;
        }

        ${({ name }) => name === 'token_validation' && css`
            width: 800px;
            height: 800px;
            fill: #c7c7c7;
            
            @media screen and (max-width: 600px) {
                width: 480px;
                height: 480px;
            }
        `}
`
const CloseIcon = styled.svg`
    ${({ name }) => name === 'filter_mobile' && css`
        width: 22px;
        height: 22px;

        fill: #F1F1F1;
        right: 0;
        transition: 500ms color ease-in,
            500ms right ease-in;

        ${({ open }) => open && css`
            fill: #000000;
            right: 7px;
        `}

    `}
`
const Search = styled.svg`

    ${({ name }) => name === 'filter_mobile' && css`
        width: 22px;
        height: 22px;
    `}

`
const Filter = styled.svg`

    ${({ name }) => name === 'filter_mobile' && css`
        width: 22px;
        height: 22px;

        @media screen and (max-width: 600px) {
            width: 18px;
            height: 18px;
        }
    `}

`
const MoodError = styled.svg`

    width: 36px;
    height: 36px;

    @media screen and (max-width: 600px) {
        width: 24px;
        height: 24px;
    }
    
`
const SvgArrowLeft = styled.svg`

    ${({ name }) => name === 'mobile_header' && css`
        width: 24px;
        height: 24px;
    `}

    ${({ name }) => name === 'register' && css`
        width: 22px;
        height: 22px;
        margin-right: 20px;

        @media screen and (max-width: 600px) {
            width: 18px;
            height: 18px;
        }
    `}
    
`
const ArrowUp = styled.svg`

    width: 24px;
    height: 24px;

    @media screen and (max-width: 600px) {
        width: 18px;
        height: 18px;
    }
    
`
const SvgArrow = styled.svg`

    ${({ name }) => name === 'filter' && css`
        width: 36px;
        height: 36px;

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 26px;
        }
    `}

    ${({ name }) => name === 'accept_project' && css`
        width: 36px;
        height: 36px;

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 26px;
        }
    `}

    ${({ name }) => name === 'register_user' && css`
        width: 36px;
        height: 36px;

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 26px;
        }
    `}

    ${({ name }) => name === 'card_competition' && css`
        width: 20px;
        height: 20px;

        @media screen and (max-width: 600px) {
            width: 16px;
            height: 16px;
        }
    `}

    ${({ name }) => name === 'register_success' && css`
        width: 15px;
        height: 15px;

        @media screen and (max-width: 600px) {
            width: 20px;
            height: 20px;
        }
    `}

    ${({ name }) => name === 'new_photo' && css`
        width: 13px;
        height: 13px;
    `}

`
const SvgArrowDown = styled.svg`

    ${({ name }) => name === 'header_down' && css`
        width: 36px;
        height: 36px;

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 26px;
        }
    `}
    
    ${({ name }) => name === 'download' && css`
        width: 18;
        height: 18px;
        margin-left: 8px;

        @media screen and (max-width: 600px) {
            width: 18x;
            height: 18px;
        }
    `}

`
const SvgClose = styled.svg`

    cursor: pointer;

    ${({ name }) => name === 'header_down' && css`
        width: 36px;
        height: 36px;

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 26px;
        }
    `}   

`
const Location = styled.svg`

    ${({ name }) => name === 'location' && css`
        width: 12px;
        height: 12px;
        fill: #444444;
        margin-right: 2px;

        @media screen and (max-width: 600px) {
            width: 12px;
            height: 12px;
        }
    `}
    
    ${({ name }) => name === 'adm' && css`
        width: 16px;
        height: 20px;
        fill: #a5a5a5;
        margin-right: 4.81px;
    `} 

`
const Schedule = styled.svg`

    ${({ name }) => name === 'schedule' && css`
        width: 12px;
        height: 12px;
        fill: #444444;
        margin-right: 4px;

        @media screen and (max-width: 600px) {
            width: 12px;
            height: 12px;
        }
    `}

`

const Pending = styled.svg`

    ${({ name }) => name === 'status_bar' && css`
        width: 18px;
        height: 18px;
        fill: #8a8a8a;
        margin-right: 8px;

        ${({ selected }) => selected && css`
            fill: #444444;
        `}
    `}

`

const Lost = styled.svg`

    ${({ name }) => name === 'status_bar' && css`
        width: 18px;
        height: 18px;
        fill: #8a8a8a;
        margin-right: 8px;

        ${({ selected }) => selected && css`
            fill: #444444;
        `}
    `}
    
`

const Won = styled.svg`

    ${({ name }) => name === 'status_bar' && css`
        width: 18px;
        height: 18px;
        fill: #8a8a8a;
        margin-right: 8px;

        ${({ selected }) => selected && css`
            fill: #444444;
        `}
    `}
    
`

const GiveUp = styled.svg`

    ${({ name }) => name === 'status_bar' && css`
        width: 18px;
        height: 18px;
        fill: #8a8a8a;
        margin-right: 8px;

        ${({ selected }) => selected && css`
            fill: #444444;
        `}
    `}
    
`
const Info = styled.svg`

    ${({ name }) => name === 'info' && css`
        width: 18px;
        height: 18px;
        fill: #000000;
    `}

`
const Smile = styled.svg`

    ${({ name }) => name === 'status' && css`
        width: 18px;
        height: 18px;
        fill: #000000;
    `}

    ${({ name }) => name === 'message' && css`

        width: 60px;
        height: 60px;
        fill: #000000;

        @media screen and (max-width: 600px) {
            width: 60px;
            height: 60px;
        }

    `}

    ${({ name }) => name === 'register_success' && css`
        width: 48px;
        height: 48px;
    `}
`
const SvgArrowEastSvg = styled.svg`
    fill: #000;
    width: 19px;
    height: 19px;
    transform: rotate(45deg);
    fill: #8A8A8A;

    ${({ menu }) => menu && css`
        fill: #000;
    `}

    ${({ marble }) => marble && css`
        display: flex;
        align-items: center;
        transform: rotate(-45deg);
        fill: #000;
        width: 18px;
        height: 18px;
        margin-right: 4.5px;
    `}

    ${({ blog }) => blog && css`
        fill: #A8A8A8!important;
    `}
`
const SvgSocialLinkedin = styled.svg`
    fill: #000;
    height: 28px;
    width: 28px;
    cursor: pointer;
`
const SvgSocialInstagram = styled.svg`
    fill: #000;
    height: 40px;
    width: 40px;
    cursor: pointer;
`
const SvgSocialFacebook = styled.svg`
    fill: #000;
    height: 34px;
    width: 36px;
    cursor: pointer;
`
const SvgSocialPinterest = styled.svg`
    fill: #000;
    height: 38px;
    width: 38px;
    cursor: pointer;
`
const SvgList = styled.svg`
    fill: #000000;
    width: 20px;
    height: 20px;
`
const SvgLocked = styled.svg`
    fill: ${({ locked }) => locked ? '#000000' : '#868686'};
    width: 14px;
    height: 15px;
`
const SvgMapSearch = styled.svg`
    fill: #000;
`
const SvgMap = styled.svg`
    fill: #000000;
    width: 18px;
    height: 18px;
`
const SvgArrowForwardMap = styled.svg`
    fill: #000;

    ${({ name }) => name === 'slide' && css`
        width: 40px;
        height: 40px;
    `}

    ${({ back }) => back && css`
        width: 18px;
        height: 18px;
    `}
`
export const ArrowRight = ({ onClick, pointer, name }) => {
    return (
        <SvgArrowForward name={name} pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/></SvgArrowForward>
    )
}

export const UnLocked = ({ locked }) => {
    return (
        <SvgLocked locked={locked}>
            <path id="Icon_awesome-unlock" data-name="Icon awesome-unlock" d="M12.109,7.75H4.6V4.629A2.18,2.18,0,1,1,8.961,4.6v.484a.725.725,0,0,0,.727.727h.969a.725.725,0,0,0,.727-.727V4.6a4.6,4.6,0,1,0-9.2.045v3.1H1.453A1.453,1.453,0,0,0,0,9.2v4.844A1.453,1.453,0,0,0,1.453,15.5H12.109a1.453,1.453,0,0,0,1.453-1.453V9.2A1.453,1.453,0,0,0,12.109,7.75Z" transform="translate(0 0)" />
        </SvgLocked>
    )
}


export const MyLocation = ({ onClick, pointer, name }) => {
    return (
        <SvgArrowForwardMap name={name} pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
        </SvgArrowForwardMap>
    )
}

export const ArrowUpMaps = ({ onClick, pointer, name }) => {
    return (
        <SvgArrowForwardMap name={name} pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/>
        </SvgArrowForwardMap>
    )
}

export const ArrowLeft = ({ onClick, pointer, name, back }) => {
    return (
        <SvgArrowForward back={back} name={name} pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></SvgArrowForward>
    )
}

export const Linkedin = ({ onClick, pointer }) => {
    return (
        <SvgSocialLinkedin onClick={onClick} pointer={pointer} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
        </SvgSocialLinkedin>
    )
}

export const Instagram = ({ onClick, pointer }) => {
    return (
        <SvgSocialInstagram onClick={onClick} pointer={pointer} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </SvgSocialInstagram>
    )
}

export const Facebook = ({ onClick, pointer }) => {
    return (
        <SvgSocialFacebook onClick={onClick} pointer={pointer} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
        </SvgSocialFacebook>
    )
}

export const Pinterest = ({ onClick, pointer }) => {
    return (
        <SvgSocialPinterest onClick={onClick} pointer={pointer} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32" width="32px" height="32px">
            <path d="M 16.09375 4 C 11.01675 4 6 7.3833281 6 12.861328 C 6 16.344328 7.9584844 18.324219 9.1464844 18.324219 C 9.6364844 18.324219 9.9199219 16.958266 9.9199219 16.572266 C 9.9199219 16.112266 8.7460938 15.131797 8.7460938 13.216797 C 8.7460938 9.2387969 11.774359 6.4199219 15.693359 6.4199219 C 19.063359 6.4199219 21.556641 8.3335625 21.556641 11.851562 C 21.556641 14.478563 20.501891 19.40625 17.087891 19.40625 C 15.855891 19.40625 14.802734 18.516234 14.802734 17.240234 C 14.802734 15.370234 16 13.558906 16 11.628906 C 16 8.3529063 11.462891 8.94725 11.462891 12.90625 C 11.462891 13.73725 11.5665 14.657063 11.9375 15.414062 C 11.2555 18.353063 10 23.037406 10 26.066406 C 10 27.001406 10.133656 27.921422 10.222656 28.857422 C 10.390656 29.045422 10.307453 29.025641 10.564453 28.931641 C 13.058453 25.517641 12.827078 24.544172 13.955078 20.076172 C 14.564078 21.234172 16.137766 21.857422 17.384766 21.857422 C 22.639766 21.857422 25 16.736141 25 12.119141 C 25 7.2061406 20.75475 4 16.09375 4 z"/>
        </SvgSocialPinterest>
    )
}


const SvgSchedule = ({ name }) => {
    return (
        <Schedule name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
        </Schedule>
    )
}

const SvgArrowDownload = ({ name, color }) => {
    return (
        <SvgArrowDown name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill={color || "#000000"}>
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/>
        </SvgArrowDown>
    )
}

const SvgArrowForward = ({ name }) => {
    return (
        <SvgArrow name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
        </SvgArrow>
    )
}

const SvgArrowBack = ({ name }) => {
    return (
        <SvgArrowLeft name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </SvgArrowLeft>
    )
}

const SvgArrowUp = ({ name }) => {
    return (
        <ArrowUp name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </ArrowUp>
    )
}

const SvgCancel = ({ name, onClick }) => {
    return (
        <SvgClose onClick={onClick} name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/>
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"/>
        </SvgClose>
    )
}

const SvgLocation = ({ name }) => {
    return (
        <Location name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
            <circle cx="12" cy="9" r="2.5"/>
        </Location>
    )
}

const SvgSquare = ({ name }) => {
    return (
        <Square name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M3 21V3h18v18Zm2-2h14V5H5Zm0 0V5v14Z"/>
        </Square>
    )
}

const SvgPending = ({ name, selected }) => {
    return (
        <Pending name={name} selected={selected} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <g>
                <rect fill="none" height="24" width="24"/>
            </g>
                <g><g>
                    <path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.42,0-8-3.58-8-8 c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z"/>
                    <circle cx="7" cy="12" r="1.5"/>
                    <circle cx="12" cy="12" r="1.5"/>
                    <circle cx="17" cy="12" r="1.5"/>
                </g>
            </g>
        </Pending>
    )
}

const SvgLost = ({ name, selected }) => {
    return (
        <Lost name={name} selected={selected} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <circle cx="15.5" cy="9.5" r="1.5"/>
            <circle cx="8.5" cy="9.5" r="1.5"/>
            <path d="M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        </Lost>
    )
}

const SvgWon = ({ name, selected }) => {
    return (
        <Won name={name} selected={selected} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <circle cx="15.5" cy="9.5" r="1.5"/>
            <circle cx="8.5" cy="9.5" r="1.5"/>
            <path d="M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        </Won>
    )
}

const SvgGiveUp = ({ name, selected }) => {
    return (
        <GiveUp name={name} selected={selected} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18 24h-6.55c-1.08 0-2.14-.45-2.89-1.23l-7.3-7.61 2.07-1.83c.62-.55 1.53-.66 2.26-.27L8 14.34V4.79c0-1.38 1.12-2.5 2.5-2.5.17 0 .34.02.51.05.09-1.3 1.17-2.33 2.49-2.33.86 0 1.61.43 2.06 1.09.29-.12.61-.18.94-.18 1.38 0 2.5 1.12 2.5 2.5v.28c.16-.03.33-.05.5-.05 1.38 0 2.5 1.12 2.5 2.5V20c0 2.21-1.79 4-4 4zM4.14 15.28l5.86 6.1c.38.39.9.62 1.44.62H18c1.1 0 2-.9 2-2V6.15c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V3.42c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V2.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V4.79c0-.28-.22-.5-.5-.5s-.5.23-.5.5v12.87l-5.35-2.83-.51.45z"/>
        </GiveUp>
    )
}

const SvgInfo = ({ name }) => {
    return (
        <Info name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
        </Info>
    )
}

const SvgProjectName = ({ name }) => {
    return (
        <ProjectName name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"/>
        </ProjectName>
    )
}

const SvgCreateDate = ({ name }) => {
    return (
        <ProjectCreatedDate name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
        </ProjectCreatedDate>
    )
}

const SvgPersonName = ({ name }) => {
    return (
        <PersonName name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </PersonName>
    )
}

const SvgEmail = ({ name }) => {
    return (
        <Email name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
        </Email>
    )
}

const SvgCall = ({ name }) => {
    return (
        <Call name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/>
        </Call>
    )
}

const SvgUserType = ({ name }) => {
    return (
        <UserType name={name} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <g>
                <rect fill="none" height="24" width="24" y="0"/>
            </g>
            <g><g>
            <rect height="1.5" width="4" x="14" y="12"/>
            <rect height="1.5" width="4" x="14" y="15"/>
            <path d="M20,7h-5V4c0-1.1-0.9-2-2-2h-2C9.9,2,9,2.9,9,4v3H4C2.9,7,2,7.9,2,9v11c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V9 C22,7.9,21.1,7,20,7z M11,7V4h2v3v2h-2V7z M20,20H4V9h5c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2h5V20z"/>
            <circle cx="9" cy="13.5" r="1.5"/>
            <path d="M11.08,16.18C10.44,15.9,9.74,15.75,9,15.75s-1.44,0.15-2.08,0.43C6.36,16.42,6,16.96,6,17.57V18h6v-0.43 C12,16.96,11.64,16.42,11.08,16.18z"/>
            </g></g>
        </UserType>
    )
}

const SvgMoodError = ({ name }) => {
    return (
        <MoodError name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"/>
        </MoodError>
    )
}

const SvgFilter = ({ name }) => {
    return (
        <Filter name={name} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <g>
                <path d="M0,0h24 M24,24H0" fill="none"/>
                <path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"/>
                <path d="M0,0h24v24H0V0z" fill="none"/>
            </g>
        </Filter>
    )
}

const SvgSearch = ({ name }) => {
    return (
        <Search name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </Search>
    )
}

const SvgCloseIcon = ({ name, open }) => {
    return (
        <CloseIcon name={name} open={open} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
        </CloseIcon>
    )
}

const SvgSmile = ({ name }) => {
    return (
        <Smile name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <circle cx="15.5" cy="9.5" r="1.5"/>
                <circle cx="8.5" cy="9.5" r="1.5"/>
                <path d="M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        </Smile>
    )
}

const SvgNoSatisfied = ({ name }) => {
    return (
        <NoSatisfied name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"/>
        </NoSatisfied>
    )
}

const SvgExpandLess = ({ name }) => {
    return (
        <ExpandLess name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"/>
        </ExpandLess>
    )
}

const SvgExpandMore = ({ name }) => {
    return (
        <ExpandMore name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/>
                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
        </ExpandMore>
    )
}

const SvgAddAPhoto = ({ name }) => {
    return (
        <AddPhoto name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M21 6h-3.17L16 4h-6v2h5.12l1.83 2H21v12H5v-9H3v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM5 6h3V4H5V1H3v3H0v2h3v3h2z"/>
        </AddPhoto>
    )
}

const SvgChevronRight = ({ name }) => {
    return (
        <ChevronRight name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
        </ChevronRight>
    )
}

const SvgInsertChartOutlined = ({ name }) => {
    return (
        <InsertChartOutlined name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </InsertChartOutlined>
    )
}

const SvgPersonSearch = ({ name }) => {
    return (
        <PersonSearch name={name} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <g>
                    <rect fill="none" height="24" width="24"/>
                </g>
                <g><g>
                    <path d="M10,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S6,5.79,6,8C6,10.21,7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2 S8,9.1,8,8C8,6.9,8.9,6,10,6z"/>
                    <path d="M4,18c0.22-0.72,3.31-2,6-2c0-0.7,0.13-1.37,0.35-1.99C7.62,13.91,2,15.27,2,18v2h9.54c-0.52-0.58-0.93-1.25-1.19-2H4z"/>
                    <path d="M19.43,18.02C19.79,17.43,20,16.74,20,16c0-2.21-1.79-4-4-4s-4,1.79-4,4c0,2.21,1.79,4,4,4c0.74,0,1.43-0.22,2.02-0.57 c0.93,0.93,1.62,1.62,2.57,2.57L22,20.59C20.5,19.09,21.21,19.79,19.43,18.02z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2 C18,17.1,17.1,18,16,18z"/>
                </g></g>
        </PersonSearch>
    )
}

const SvgHelpOutline = ({ name }) => {
    return (
        <HelpOutline name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
        </HelpOutline>
    )
}

const SvgPersonOutline = ({ name }) => {
    return (
        <PersonOutline name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/>
        </PersonOutline>
    )
}

const SvgSettings = ({ name }) => {
    return (
        <SettingsOutline name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <g><path d="M0,0h24v24H0V0z" fill="none"/><path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/></g>
        </SettingsOutline>
    )
}

const SvgManageAccounts = ({ name }) => {
    return (
        <SettingsOutline name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M10 12q-1.65 0-2.825-1.175Q6 9.65 6 8q0-1.65 1.175-2.825Q8.35 4 10 4q1.65 0 2.825 1.175Q14 6.35 14 8q0 1.65-1.175 2.825Q11.65 12 10 12Zm-8 8v-2.8q0-.825.425-1.55.425-.725 1.175-1.1 1.275-.65 2.875-1.1Q8.075 13 10 13h.35q.15 0 .3.05-.2.45-.338.938-.137.487-.212 1.012H10q-1.775 0-3.188.45-1.412.45-2.312.9-.225.125-.362.35-.138.225-.138.5v.8h6.3q.15.525.4 1.038.25.512.55.962Zm14 1-.3-1.5q-.3-.125-.563-.262-.262-.138-.537-.338l-1.45.45-1-1.7 1.15-1q-.05-.35-.05-.65 0-.3.05-.65l-1.15-1 1-1.7 1.45.45q.275-.2.537-.338.263-.137.563-.262L16 11h2l.3 1.5q.3.125.563.275.262.15.537.375l1.45-.5 1 1.75-1.15 1q.05.3.05.625t-.05.625l1.15 1-1 1.7-1.45-.45q-.275.2-.537.338-.263.137-.563.262L18 21Zm1-3q.825 0 1.413-.587Q19 16.825 19 16q0-.825-.587-1.413Q17.825 14 17 14q-.825 0-1.412.587Q15 15.175 15 16q0 .825.588 1.413Q16.175 18 17 18Zm-7-8q.825 0 1.413-.588Q12 8.825 12 8t-.587-1.412Q10.825 6 10 6q-.825 0-1.412.588Q8 7.175 8 8t.588 1.412Q9.175 10 10 10Zm0-2Zm.3 10Z"/>
        </SettingsOutline>
    )
}

const SvgEdit = ({ name }) => {
    return (
        <Edit name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
        </Edit>
    )
}

const SvgWorkOutline = ({ name }) => {
    return (
        <WorkOutline name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"/>
        </WorkOutline>
    )
}

const SvgEmojiEvents = ({ name }) => {
    return (
        <EmojiEvents name={name} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <rect fill="none" height="24" width="24"/>
                <path d="M19,5h-2V3H7v2H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94c0.63,1.5,1.98,2.63,3.61,2.96V19H7v2h10v-2h-4v-3.1 c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14 c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z"/>
        </EmojiEvents>
    )
}

const SvgSpaceDashboard = ({ name }) => {
    return (
        <SpaceDashboard name={name} xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                <rect fill="none" height="24" width="24"/>
                <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M5,19V5h6v14H5z M19,19h-6v-7h6V19z M19,10h-6V5h6V10z"/>
        </SpaceDashboard>
    )
}

const SvgSuperAdm = ({ name }) => {
    return (
        <SpaceSuperAdm name={name} xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <g><path d="M0,0h24v24H0V0z" fill="none"/><path d="M0,0h24v24H0V0z" fill="none"/></g><g><path d="M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"/></g>
        </SpaceSuperAdm>
    )
}

const SvgFileDownload = ({ name }) => {
    return (
        <FileDownload name={name} xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <g><rect fill="none" height="24" width="24"/></g><g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"/></g>
        </FileDownload>
    )
}

const SvgThumbUpBlack = ({ name }) => {
    return (
        <ThumbUpBlack name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"/>
        </ThumbUpBlack>
    )
}

const SvgThumbDownBlack = ({ name }) => {
    return (
        <ThumbDownBlack name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z"/>
        </ThumbDownBlack>
    )
}

const SvgAlarmBlack = ({ name }) => {
    return (
        <AlarmBlack name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/><path d="M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
        </AlarmBlack>
    )
}

const SvgDateRangeBlack = ({ name }) => {
    return (
        <DateRangeBlack name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"/>
        </DateRangeBlack>
    )
}

const SvgNotifications = ({ name }) => {
    return (
        <InsertChartOutlined name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"/>
        </InsertChartOutlined>
    )
}

const SvgNotificationsActive = ({ name }) => {
    return (
        <Notifications name={name} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M2 10Q2 7.8 2.888 5.838Q3.775 3.875 5.425 2.45L6.85 3.85Q5.5 5.025 4.75 6.612Q4 8.2 4 10ZM20 10Q20 8.2 19.25 6.612Q18.5 5.025 17.15 3.85L18.575 2.45Q20.225 3.875 21.113 5.838Q22 7.8 22 10ZM4 19V17H6V10Q6 7.925 7.25 6.312Q8.5 4.7 10.5 4.2V3.5Q10.5 2.875 10.938 2.438Q11.375 2 12 2Q12.625 2 13.062 2.438Q13.5 2.875 13.5 3.5V4.2Q15.5 4.7 16.75 6.312Q18 7.925 18 10V17H20V19ZM12 11.5Q12 11.5 12 11.5Q12 11.5 12 11.5Q12 11.5 12 11.5Q12 11.5 12 11.5ZM12 22Q11.175 22 10.588 21.413Q10 20.825 10 20H14Q14 20.825 13.413 21.413Q12.825 22 12 22ZM8 17H16V10Q16 8.35 14.825 7.175Q13.65 6 12 6Q10.35 6 9.175 7.175Q8 8.35 8 10Z"/>
        </Notifications>
    )
}

const ArrowEast = ({ onClick, pointer, menu, marble, selected, blog }) => {
    return (
        <SvgArrowEastSvg blog={blog} selected={selected} marble={marble} menu={menu} pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></SvgArrowEastSvg>
    )
}

export const MapSearchIcon = () => {
    return (
        <SvgMapSearch height="48px" viewBox="0 0 24 24" width="48px" fill="#000000"><g>
            <path d="M0,0h24v24H0V0z" fill="none"/></g><g><path d="M7,9H2V7h5V9z M7,12H2v2h5V12z M20.59,19l-3.83-3.83C15.96,15.69,15.02,16,14,16c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5 c0,1.02-0.31,1.96-0.83,2.75L22,17.59L20.59,19z M17,11c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S17,12.65,17,11z M2,19h10v-2H2 V19z"/></g>
        </SvgMapSearch>
    )
}

export const Phone = ({ onClick, pointer, phone }) => {
    return (
        <Svg phone pointer={pointer} onClick={onClick} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/></Svg>
    )
}

export const List = () => {
    return (
        <SvgList height="18px" viewBox="0 0 24 24" width="18px" >
            <g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
        </SvgList>
    )
}

export const Locked = ({ locked }) => {
    return (
        <SvgLocked locked={locked}>
            <path id="Icon_awesome-lock" data-name="Icon awesome-lock" d="M12.109,6.781h-.727V4.6a4.6,4.6,0,0,0-9.2,0v2.18H1.453A1.453,1.453,0,0,0,0,8.234v5.812A1.453,1.453,0,0,0,1.453,15.5H12.109a1.453,1.453,0,0,0,1.453-1.453V8.234A1.453,1.453,0,0,0,12.109,6.781Zm-3.148,0H4.6V4.6a2.18,2.18,0,0,1,4.359,0Z" />
        </SvgLocked>
    )
}

export const Maps = () => {
    return (
        <SvgMap height="18px" viewBox="0 0 24 24" width="18px">
            <path d="M0 0h24v24H0V0z" fill="none"/><path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"/>
        </SvgMap>
    )
}


export {
    SvgArrowForward,
    SvgArrowDownload,
    SvgCancel,
    SvgLocation,
    SvgSchedule,
    SvgPending,
    SvgLost,
    SvgGiveUp,
    SvgInfo,
    SvgArrowBack,
    SvgArrowUp,
    SvgProjectName,
    SvgCreateDate,
    SvgPersonName,
    SvgEmail,
    SvgCall,
    SvgUserType,
    SvgMoodError,
    SvgFilter,
    SvgSearch,
    SvgCloseIcon,
    SvgSmile,
    SvgNoSatisfied,
    SvgExpandLess,
    SvgExpandMore,
    SvgAddAPhoto,
    SvgChevronRight,
    SvgInsertChartOutlined,
    SvgPersonSearch,
    SvgHelpOutline,
    SvgPersonOutline,
    SvgEdit,
    SvgWorkOutline,
    SvgEmojiEvents,
    SvgSpaceDashboard,
    SvgSuperAdm,
    SvgFileDownload,
    SvgThumbUpBlack,
    SvgThumbDownBlack,
    SvgAlarmBlack,
    SvgDateRangeBlack,
    SvgWon,
    SvgNotifications,
    SvgNotificationsActive,
    SvgSettings,
    SvgSquare,
    ArrowEast,
    SvgManageAccounts
}